import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { forms as Forms } from '@breezeway/brzw-components';

import './buttons_select_formik.scss';

const ButtonsSelectFormik = ({
  className,
  field,
  form,
  id,
  label,
  labelClassName,
  options,
  required,
  shouldAdaptColors,
  theme,
}) => {
  const { setFieldValue } = form;

  return (
    <Forms.ButtonsSelect
      className={classnames(className, {
        'buttons-select-formik--adaptive-colors': shouldAdaptColors,
      })}
      id={id}
      isRequired={required}
      labelClassName={labelClassName}
      labelText={label}
      onSelect={value => setFieldValue(field.name, value)}
      options={options}
      selected={field.value}
      theme={theme}
    />
  );
};

ButtonsSelectFormik.propTypes = {
  className: PropTypes.string,
  field: PropTypes.shape({}),
  form: PropTypes.shape({}),
  id: PropTypes.string,
  label: PropTypes.string,
  labelClassName: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  required: PropTypes.bool,
  shouldAdaptColors: PropTypes.bool,
  theme: PropTypes.string,
};

ButtonsSelectFormik.defaultProps = {
  className: '',
  required: false,
};

export default ButtonsSelectFormik;
